import React from 'react';
import ProjectOverviewPage from '../../Pages/ProjectOverviewPage';

const ProjectOverviewContainer = () => {
  return <ProjectOverviewPage></ProjectOverviewPage>;
};

export default ProjectOverviewContainer;
